/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as Types from '../../graph/types';

import { gql } from '@apollo/client';
import { ChildrenFieldsFragmentDoc } from './ChildrenFields';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InterviewQueryVariables = Types.Exact<{
  urn: Types.Scalars['String']['input'];
  internalCaseReferenceID: Types.Scalars['String']['input'];
}>;


export type InterviewQuery = { __typename?: 'Query', statusReport: { __typename?: 'StatusReport', client: { __typename?: 'ReportClient', dateOfBirth?: string | null }, lifeAppliedPolicy?: { __typename?: 'LifeAppliedPolicy', coverageAmount: number } | null }, interview?: { __typename?: 'Interview', urn: string, dpidUrns: Array<string>, nodes: Array<{ __typename?: 'Node', urn: string, nodeType: string, questionType: string, content: string, helpText?: string | null, rules?: string | null, children?: Array<{ __typename?: 'Node', urn: string, nodeType: string, questionType: string, content: string, helpText?: string | null, rules?: string | null, children?: Array<{ __typename?: 'Node', urn: string, nodeType: string, questionType: string, content: string, helpText?: string | null, rules?: string | null, dataPoint?: { __typename?: 'DataPointID', urn: string, dataType: Types.DataType, subtype: Types.Subtype, repeatable?: boolean | null, compositeStructure?: Array<{ __typename?: 'CompositeStructure', key: string, value?: { __typename?: 'Composite', dataType?: Types.DataType | null, sensitive?: boolean | null } | null } | null> | null } | null, choices?: Array<{ __typename?: 'Choice', valueType?: Types.ValueType | null, valueInt: number, valueText: string, displayText: string }> | null }> | null, dataPoint?: { __typename?: 'DataPointID', urn: string, dataType: Types.DataType, subtype: Types.Subtype, repeatable?: boolean | null, compositeStructure?: Array<{ __typename?: 'CompositeStructure', key: string, value?: { __typename?: 'Composite', dataType?: Types.DataType | null, sensitive?: boolean | null } | null } | null> | null } | null, choices?: Array<{ __typename?: 'Choice', valueType?: Types.ValueType | null, valueInt: number, valueText: string, displayText: string }> | null }> | null, dataPoint?: { __typename?: 'DataPointID', urn: string, dataType: Types.DataType, subtype: Types.Subtype, repeatable?: boolean | null, compositeStructure?: Array<{ __typename?: 'CompositeStructure', key: string, value?: { __typename?: 'Composite', dataType?: Types.DataType | null, sensitive?: boolean | null } | null } | null> | null } | null, choices?: Array<{ __typename?: 'Choice', valueType?: Types.ValueType | null, valueInt: number, valueText: string, displayText: string }> | null }>, savedDpids?: { __typename?: 'MappedDpidData', dpids?: Array<{ __typename?: 'DataPointIDMapping', dataPointIdUrn: string, dataType: Types.DataValueTypes, stringValue?: string | null, floatValue?: number | null, intValue?: number | null, boolValue?: boolean | null, stringListValue?: Array<string | null> | null, intListValue?: Array<number | null> | null, dateValue?: { __typename?: 'Date', year?: number | null, month?: number | null, day?: number | null } | null } | null> | null, repeatableDpids?: Array<{ __typename?: 'RepeatableDataPointMapping', dataPointIdUrn: string, values: Array<{ __typename?: 'RepeatableMap', valueMap?: Array<{ __typename?: 'KeyValuePair', shortUrn: string, value: { __typename?: 'DataPointIDMapping', dataPointIdUrn: string, dataType: Types.DataValueTypes, stringValue?: string | null, floatValue?: number | null, intValue?: number | null, boolValue?: boolean | null, stringListValue?: Array<string | null> | null, intListValue?: Array<number | null> | null, dateValue?: { __typename?: 'Date', year?: number | null, month?: number | null, day?: number | null } | null } } | null> | null } | null> } | null> | null } | null } | null };


export const InterviewDocument = gql`
    query Interview($urn: String!, $internalCaseReferenceID: String!) {
  statusReport(input: $internalCaseReferenceID) {
    client {
      dateOfBirth
    }
    lifeAppliedPolicy {
      coverageAmount
    }
  }
  interview(interviewUrn: $urn, internalCaseReferenceID: $internalCaseReferenceID) {
    urn
    nodes {
      ...ChildrenFields
    }
    dpidUrns
    savedDpids {
      dpids {
        dataPointIdUrn
        dataType
        stringValue
        dateValue {
          year
          month
          day
        }
        floatValue
        intValue
        boolValue
        stringListValue
        intListValue
      }
      repeatableDpids {
        dataPointIdUrn
        values {
          valueMap {
            shortUrn
            value {
              dataPointIdUrn
              dataType
              stringValue
              dateValue {
                year
                month
                day
              }
              floatValue
              intValue
              boolValue
              stringListValue
              intListValue
            }
          }
        }
      }
    }
  }
}
    ${ChildrenFieldsFragmentDoc}`;

/**
 * __useInterviewQuery__
 *
 * To run a query within a React component, call `useInterviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewQuery({
 *   variables: {
 *      urn: // value for 'urn'
 *      internalCaseReferenceID: // value for 'internalCaseReferenceID'
 *   },
 * });
 */
export function useInterviewQuery(baseOptions: Apollo.QueryHookOptions<InterviewQuery, InterviewQueryVariables> & ({ variables: InterviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewQuery, InterviewQueryVariables>(InterviewDocument, options);
      }
export function useInterviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewQuery, InterviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewQuery, InterviewQueryVariables>(InterviewDocument, options);
        }
export function useInterviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewQuery, InterviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewQuery, InterviewQueryVariables>(InterviewDocument, options);
        }
export type InterviewQueryHookResult = ReturnType<typeof useInterviewQuery>;
export type InterviewLazyQueryHookResult = ReturnType<typeof useInterviewLazyQuery>;
export type InterviewSuspenseQueryHookResult = ReturnType<typeof useInterviewSuspenseQuery>;
export type InterviewQueryResult = Apollo.QueryResult<InterviewQuery, InterviewQueryVariables>;